import ApiClient from "@/api/api-client";
import ENDPOINTS from "@/api/endpoints";
import mapbox from "@/config/mapbox";
import axios from "axios";

export default {
  getAllCoordinates() {
    return ApiClient.get(ENDPOINTS.GET_ALL_COORDINATES)
  },
  getCoordinate(coordinateId) {
    return ApiClient.get(ENDPOINTS.GET_COORDINATE(coordinateId))
  },
  getCoordinateImage(coordinateId) {
    return ApiClient.get(ENDPOINTS.GET_COORDINATE_IMAGE(coordinateId))
  },
  getImage(imageId) {
    return ApiClient.get(ENDPOINTS.GET_IMAGE(imageId))
  },
  getImageBySrcNumber(srcNumber) {
    return ApiClient.get(ENDPOINTS.GET_IMAGE_BY_SRC_NUMBER(srcNumber))
  },
  getByFilter(filters = {}) {
    return ApiClient.get(ENDPOINTS.FILTER, {
      params: filters
    })
  },
  getTags() {
    return ApiClient.get(ENDPOINTS.GET_TAGS)
  },
  getSettings() {
    return ApiClient.get(ENDPOINTS.GET_SETTINGS)
  },
  getRoutes() {
    return ApiClient.get(ENDPOINTS.GET_ROUTES)
  },

  getMapboxRoute(coordinates, profile = mapbox.defaultMapRouteProfile, accessToken = mapbox.accessToken) {
    return ApiClient.get(ENDPOINTS.GET_MAPBOX_ROUTE(coordinates, profile), {
      params: {
        access_token: accessToken,
        steps: true,
        radiuses: (new Array(coordinates.length)).fill(500).join(';'),
        geometries: "geojson",
        alternatives: true,
        continue_straight: false
      }
    })
  },

  getIpLocationWithTimestamp() {
    return axios.get("https://ipapi.co/json").then((response) => {
      const dataWithTimestamp = {
        ...response.data,
        timestamp: new Date().toISOString(),
      };
      return dataWithTimestamp;
    });
  },
  postVisitorData(data) {
    return ApiClient.post(ENDPOINTS.POST_VISITOR_DATA, data);
  },
}
